import {Button} from "@/components/ui/button";

export default function CandidateGeneralView({ data, onEdit, onToggleLogin }) {


    return (
        <>
            <div className="p-4 mb-4 border rounded-lg bg-white shadow-sm flex items-center justify-between">
                <div className="font-bold text-lg">
    <span className={data.loginEnabled ? "text-green-600" : "text-red-600"}>
      Login: {data.loginEnabled ? "Enabled" : "Disabled"}
    </span>
                </div>
                <Button
                    variant={data.loginEnabled ? "destructive" : ""}
                    className={!data.loginEnabled ? "bg-brand-500" : ""}
                    onClick={onToggleLogin}
                >
                    {data.loginEnabled ? "Disable Login" : "Enable Login"}
                </Button>
            </div>
            <div className="p-4 border rounded-lg bg-white shadow-sm">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold">General Information</h3>
                    <button
                        onClick={onEdit}
                        className="px-3 py-1 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                    >
                        Edit
                    </button>
                </div>

                {/* Personal Information */}
                <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2">Personal Details</h4>
                    <p><strong>First Name:</strong> {data.firstName}</p>
                    <p><strong>Last Name:</strong> {data.lastName}</p>
                    <p><strong>Known As:</strong> {data.knownAs || "N/A"}</p>
                    <p><strong>Gender:</strong> {data.gender || "N/A"}</p>
                    <p><strong>Nationality:</strong> {data.nationality || "N/A"}</p>
                    <p><strong>Date of Birth:</strong> {data.dob || "N/A"}</p>
                </div>

                {/* Contact Information */}
                <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2">Contact Information</h4>
                    <p><strong>Phone Number:</strong> {data.phoneNumber}</p>
                    <p><strong>Email Address:</strong> {data.email}</p>
                </div>

                {/* Address Information */}
                {data.address && (
                    <div className="mb-6">
                        <h4 className="text-lg font-semibold mb-2">Address</h4>
                        <p><strong>Line 1:</strong> {data.address.line1}</p>
                        <p><strong>Line 2:</strong> {data.address.line2 || "N/A"}</p>
                        <p><strong>Line 3:</strong> {data.address.line3 || "N/A"}</p>
                        <p><strong>Town:</strong> {data.address.town}</p>
                        <p><strong>County:</strong> {data.address.county}</p>
                        <p><strong>Postcode:</strong> {data.address.postcode}</p>
                    </div>
                )}


                {/* Payroll Information */}
                <div className="mb-6">
                    <h4 className="text-lg font-semibold mb-2">Payroll Details</h4>
                    <p><strong>NI Number:</strong> {data.niNumber || "N/A"}</p>
                    <p><strong>Payroll Number:</strong> {data.payrollNumber || "N/A"}</p>
                    <p><strong>Pay Method:</strong> {data.payMethod || "N/A"}</p>
                    <p><strong>Payroll Method:</strong> {data.payrollMethod || "N/A"}</p>
                </div>

                {/* Bank Account Information */}
                {data.bankAccount && (
                    <div className="mb-6">
                        <h4 className="text-lg font-semibold mb-2">Bank Account Details</h4>
                        <p><strong>Account Holder Name:</strong> {data.bankAccount.accountHolderName || "N/A"}</p>
                        <p><strong>Sort Code:</strong> {data.bankAccount.sortCode || "N/A"}</p>
                        <p><strong>Bank Account Number:</strong> {data.bankAccount.bankAccountNumber || "N/A"}</p>
                    </div>
                )}

                {/* Status & Job Information */}
                <div>
                    <h4 className="text-lg font-semibold mb-2">Status & Job</h4>
                    <p><strong>Status:</strong> {data.status || "N/A"}</p>
                    <p><strong>Contact Date:</strong> {data.contactDate || "N/A"}</p>
                    <p><strong>Job Title:</strong> {data.jobTitle || data.mainSkill?.name || "N/A"}</p>
                    <p><strong>Start Date:</strong> {data.startDate || "N/A"}</p>
                </div>
            </div>
        </>
    );
}
